import { useSessionStorage } from "../../../hooks/";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logo from "@shared/Logo";
import { getMyAgentApplication } from "@services/krent.service";
import { Fragment, useEffect } from "react";
import { ROLES } from "@utils/constants";

interface MenuItem {
  to: string;
  icon: string | React.ReactNode;
  label: string;
  end?: boolean;
}

export const DashboardSideBar = ({
  showMobileSidebar,
  setShowMobileSidebar,
}: any) => {
  const [user] = useSessionStorage("user", {});
  const location = useLocation();

  const handleExploreClick = () => {
    sessionStorage.removeItem("propertyListPage");
    if (setShowMobileSidebar) {
      setShowMobileSidebar(false);
    }
  };

  const landlordMenuItems: MenuItem[] = [
    {
      to: "/overview/",
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.67266 9.79427H2.4435C2.01566 9.79669 1.60617 9.96835 1.30449 10.2717C1.00282 10.5751 0.833489 10.9856 0.833496 11.4134V14.6426C0.833496 15.0696 1.00312 15.4791 1.30505 15.781C1.60699 16.083 2.0165 16.2526 2.4435 16.2526H5.67266C6.10043 16.2526 6.5108 16.0833 6.81406 15.7816C7.11732 15.4799 7.28879 15.0704 7.291 14.6426V11.4134C7.291 10.9842 7.12049 10.5726 6.817 10.2691C6.5135 9.96561 6.10187 9.7951 5.67266 9.7951M5.67266 0.835938H2.4435C2.23207 0.835938 2.02271 0.877581 1.82738 0.958491C1.63204 1.0394 1.45456 1.15799 1.30505 1.3075C1.15555 1.457 1.03696 1.63448 0.95605 1.82982C0.87514 2.02515 0.833496 2.23451 0.833496 2.44594V5.6751C0.83349 6.10287 1.00285 6.51324 1.30454 6.8165C1.60624 7.11976 2.01573 7.29123 2.4435 7.29344H5.67266C6.10187 7.29344 6.5135 7.12294 6.817 6.81944C7.12049 6.51594 7.291 6.10431 7.291 5.6751V2.44594C7.28879 2.01817 7.11732 1.60868 6.81406 1.30699C6.5108 1.00529 6.10043 0.835932 5.67266 0.835938ZM14.6402 0.835938H11.411C10.9832 0.835932 10.5729 1.00529 10.2696 1.30699C9.96634 1.60868 9.79487 2.01817 9.79266 2.44594V5.6751C9.79288 6.10425 9.96346 6.51575 10.2669 6.8192C10.5704 7.12264 10.9819 7.29322 11.411 7.29344H14.6402C15.0679 7.29123 15.4774 7.11976 15.7791 6.8165C16.0808 6.51324 16.2502 6.10287 16.2502 5.6751V2.44594C16.2502 2.01894 16.0805 1.60943 15.7786 1.3075C15.4767 1.00556 15.0672 0.835938 14.6402 0.835938ZM13.021 9.79427C12.1646 9.79427 11.3432 10.1345 10.7376 10.7401C10.132 11.3457 9.79183 12.167 9.79183 13.0234C9.79183 13.8799 10.132 14.7012 10.7376 15.3068C11.3432 15.9124 12.1646 16.2526 13.021 16.2526C13.8774 16.2526 14.6988 15.9124 15.3044 15.3068C15.9099 14.7012 16.2502 13.8799 16.2502 13.0234C16.2502 12.167 15.9099 11.3457 15.3044 10.7401C14.6988 10.1345 13.8774 9.79427 13.021 9.79427Z"
            stroke="#000"
            strokeWidth="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      label: "Overview",
    },
    // { to: "/caution-fee", icon: "iconly-Wallet icli", label: "Caution fee" },
    { to: "/listings", icon: "iconly-Paper icli", label: "Listings" },
    { to: "/requests", icon: "iconly-Star icli", label: "Requests" },
  ];

  const userMenuItems: MenuItem[] = [
    {
      to: "/explore-listings/",
      icon: (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.67266 9.79427H2.4435C2.01566 9.79669 1.60617 9.96835 1.30449 10.2717C1.00282 10.5751 0.833489 10.9856 0.833496 11.4134V14.6426C0.833496 15.0696 1.00312 15.4791 1.30505 15.781C1.60699 16.083 2.0165 16.2526 2.4435 16.2526H5.67266C6.10043 16.2526 6.5108 16.0833 6.81406 15.7816C7.11732 15.4799 7.28879 15.0704 7.291 14.6426V11.4134C7.291 10.9842 7.12049 10.5726 6.817 10.2691C6.5135 9.96561 6.10187 9.7951 5.67266 9.7951M5.67266 0.835938H2.4435C2.23207 0.835938 2.02271 0.877581 1.82738 0.958491C1.63204 1.0394 1.45456 1.15799 1.30505 1.3075C1.15555 1.457 1.03696 1.63448 0.95605 1.82982C0.87514 2.02515 0.833496 2.23451 0.833496 2.44594V5.6751C0.83349 6.10287 1.00285 6.51324 1.30454 6.8165C1.60624 7.11976 2.01573 7.29123 2.4435 7.29344H5.67266C6.10187 7.29344 6.5135 7.12294 6.817 6.81944C7.12049 6.51594 7.291 6.10431 7.291 5.6751V2.44594C7.28879 2.01817 7.11732 1.60868 6.81406 1.30699C6.5108 1.00529 6.10043 0.835932 5.67266 0.835938ZM14.6402 0.835938H11.411C10.9832 0.835932 10.5729 1.00529 10.2696 1.30699C9.96634 1.60868 9.79487 2.01817 9.79266 2.44594V5.6751C9.79288 6.10425 9.96346 6.51575 10.2669 6.8192C10.5704 7.12264 10.9819 7.29322 11.411 7.29344H14.6402C15.0679 7.29123 15.4774 7.11976 15.7791 6.8165C16.0808 6.51324 16.2502 6.10287 16.2502 5.6751V2.44594C16.2502 2.01894 16.0805 1.60943 15.7786 1.3075C15.4767 1.00556 15.0672 0.835938 14.6402 0.835938ZM13.021 9.79427C12.1646 9.79427 11.3432 10.1345 10.7376 10.7401C10.132 11.3457 9.79183 12.167 9.79183 13.0234C9.79183 13.8799 10.132 14.7012 10.7376 15.3068C11.3432 15.9124 12.1646 16.2526 13.021 16.2526C13.8774 16.2526 14.6988 15.9124 15.3044 15.3068C15.9099 14.7012 16.2502 13.8799 16.2502 13.0234C16.2502 12.167 15.9099 11.3457 15.3044 10.7401C14.6988 10.1345 13.8774 9.79427 13.021 9.79427Z"
            stroke="#292929"
            strokeWidth="1.66667"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      ),
      label: "Explore",
      end: true,
    },
    {
      to: "/my-bookings",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_8912_11260)">
            <path
              d="M13.3335 13.3307C13.3335 12.4099 10.7218 11.6641 7.50016 11.6641M13.3335 13.3307C13.3335 14.2516 10.7218 14.9974 7.50016 14.9974C4.2785 14.9974 1.66683 14.2516 1.66683 13.3307M13.3335 13.3307V17.4449C13.3335 18.3941 10.7218 19.1641 7.50016 19.1641C4.2785 19.1641 1.66683 18.3949 1.66683 17.4449V13.3307M13.3335 13.3307C16.5202 13.3307 19.1668 12.5082 19.1668 11.6641V3.33073M7.50016 11.6641C4.2785 11.6641 1.66683 12.4099 1.66683 13.3307M7.50016 11.6641C3.8185 11.6641 0.833496 10.8416 0.833496 9.9974V5.83073M7.50016 4.16406C3.8185 4.16406 0.833496 4.9099 0.833496 5.83073M0.833496 5.83073C0.833496 6.75156 3.8185 7.4974 7.50016 7.4974C7.50016 8.34156 10.211 9.16406 13.3977 9.16406C16.5835 9.16406 19.1668 8.34156 19.1668 7.4974M19.1668 3.33073C19.1668 2.4099 16.5835 1.66406 13.3977 1.66406C10.211 1.66406 7.6285 2.4099 7.6285 3.33073M19.1668 3.33073C19.1668 4.25156 16.5835 4.9974 13.3977 4.9974C10.2118 4.9974 7.6285 4.25156 7.6285 3.33073M7.6285 3.33073V11.8024"
              stroke="#292929"
              strokeWidth="1.5"
            />
          </g>
          <defs>
            <clipPath id="clip0_8912_11260">
              <rect width="20" height="20" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      label: "My Bookings",
    },
  ];

  const userOnlyItems: MenuItem[] = [
    { to: "/caution-fee", icon: "iconly-Wallet icli", label: "Caution fee" },
  ];

  const getMenuItems = (): MenuItem[] => {
    if (
      user?.role === ROLES.LANDLORD ||
      user?.role === ROLES.AGENT ||
      user?.role === ROLES.PROPERTY_MANAGER
    ) {
      return landlordMenuItems;
    }
    return userMenuItems;
  };

  useEffect(() => {
    if (!user?._id) return;

    let abortController = new AbortController();
    getMyAgentApplication(abortController.signal)
      .then((res: any) => {
        if (res?.success && res?.data) {
          if (res.data.status === "approved") {
            //
          }
        }
      })
      .catch(() => {
        // Error fetching agent application
      });

    return () => abortController.abort();
  }, [user?.id]);

  return (
    <div
      className={`col-12  col-lg-3 col-xl-2 bg-light text-dark px-0 fixed-top side-bar ${showMobileSidebar ? "d-block" : "d-none"} d-lg-block`}
    >
      <div className="d-flex flex-column flex-shrink-0 position-relative">
        <div className="px-2 pt-3 pt-md-0 mb-auto">
          <div className="d-flex align-items-center justify-content-between mb-3 px-4">
            <div className="d-flex align-items-center">
              <Link
                className="navbar-brand fw-bolder align-middle"
                to="/"
                onClick={() =>
                  setShowMobileSidebar && setShowMobileSidebar(false)
                }
              >
                <Logo two width={"130px"} />
              </Link>
            </div>
            <div className="d-flex align-items-center d-lg-none">
              <button
                className="btn-close btn-close-dark"
                onClick={() =>
                  setShowMobileSidebar && setShowMobileSidebar(false)
                }
              ></button>
            </div>
          </div>

          <div
            className="fs-14 fw-600 mobile-sidebar-scroll"
            id="navbarNavAltMarku"
          >
            <div className="row mt-2 p-3 pb-5">
              {getMenuItems().map((item, index) => (
                <Fragment key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.end}
                    onClick={() =>
                      item.to === "/explore-listings/" && handleExploreClick()
                    }
                    className={({ isActive }) =>
                      `sidebar-link px-3 border-round d-flex align-middle ${
                        index === 0 ? "" : "mb-2"
                      } ${isActive || (item.to === "/explore-listings/" && location.pathname.includes("/explore-listings")) ? "active" : ""}`
                    }
                  >
                    {typeof item.icon === "string" ? (
                      <i
                        className={`${item.icon} mr-1 ml-1 fs-22 text-black`}
                      ></i>
                    ) : (
                      <span className="mr-1 ml-1">{item.icon}</span>
                    )}
                    <span>{item.label}</span>
                  </NavLink>
                </Fragment>
              ))}

              {user?.role !== ROLES.LANDLORD &&
                user?.role !== ROLES.AGENT &&
                user?.role !== ROLES.PROPERTY_MANAGER &&
                userOnlyItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    className="sidebar-link px-3 border-round d-flex align-middle mb-2"
                  >
                    {typeof item.icon === "string" ? (
                      <i
                        className={`${item.icon} mr-1 ml-1 fs-22 text-black`}
                      ></i>
                    ) : (
                      <span className="mr-1 ml-1">{item.icon}</span>
                    )}
                    <span>{item.label}</span>
                  </NavLink>
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
